export default "__VITE_ASSET__8a0da69b__"